export default __webpack_public_path__ + "static/media/white-hand-icon.f860ddf1.svg";